import { createSlice } from "@reduxjs/toolkit";
import { GEN_1_MACHINE_PRODUCT_VARIANT_ID } from "../../utils/constants";

const machineInitialState = {
  machine: null,
  selectedMachineVariantId: null,
};

const machineSlice = createSlice({
  name: "machine",
  initialState: machineInitialState,
  reducers: {
    selectMachine: (state, action) => {
      state.machine = action.payload;
      state.selectedMachineVariantId =
        action.payload === "need" ? GEN_1_MACHINE_PRODUCT_VARIANT_ID : null;
    },
    selectMachineVariantId: (state, action) => {
      state.selectedMachineVariantId = action.payload;
    },
  },
});

export const { selectMachine, selectMachineVariantId } = machineSlice.actions;

export default machineSlice.reducer;
